export const CALENDAR_ROOT = '/calendar'
export const EDIT_CALENDAR_EMPLOYEE = '/calendar/employee/edit/:id'